import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { InvestmentBasicInformationUploader } from '../atomic-components/InvestmentBasicInformationUploader';
import { InvestmentInformationUploader } from '../atomic-components/InvestmentInformationUploader';
import { InvestmentConditionsUploader } from '../atomic-components/InvestmentConditionsUploader';
import { RentalAgreementUploader } from '../atomic-components/RentalAgreementUploader';
import { ExpertProtocolUploader } from '../atomic-components/ExpertProtocolUploader';
import { LandRegisterUploader } from '../atomic-components/LandRegisterUploader';
import { EnergyCertificateUploader } from '../atomic-components/EnergyCertificateUploader';
import { UtilityReportUplaoder } from '../atomic-components/UtilityReportUploader';
import { AdditionalDocumentsUploader } from '../atomic-components/AdditionalDocumentsUploader';

export const AssetApprovalDocuments = () => {
  return (
    <LaunchpadCard title={'Documents'}>
      <InvestmentBasicInformationUploader />
      <InvestmentInformationUploader />
      <InvestmentConditionsUploader />
      <RentalAgreementUploader />
      <ExpertProtocolUploader />
      <LandRegisterUploader />
      <EnergyCertificateUploader />
      <UtilityReportUplaoder />
      <AdditionalDocumentsUploader />
    </LaunchpadCard>
  );
};
